import type { KnowledgeNodeId } from "../knowledge/KnowledgeGraph";

export type ArtifactCategory = "mineral" | "fossil" | "tool" | "curiosity" | "document" | "biological" | "numismatic" | "optical";
export type ArtifactRarity = "common" | "uncommon" | "rare";

export interface ArtifactTransform {
  readonly action: string;
  readonly produces: string;
  readonly message: string;
}

export interface ArtifactDefinition {
  readonly id: string;
  readonly title: string;
  readonly category: ArtifactCategory;
  readonly asset: string;
  readonly interactions: readonly string[];
  readonly knowledgeNodes: readonly KnowledgeNodeId[];
  readonly rarity: ArtifactRarity;
  /** When inspecting reveals this is really a different, known artifact (e.g. "unknown stone" -> "amber"). */
  readonly revealsAs?: string;
  readonly relatedArtifacts?: readonly string[];
  readonly transforms?: readonly ArtifactTransform[];
}

export class ArtifactRegistry {
  private readonly definitions = new Map<string, ArtifactDefinition>();

  register(definition: ArtifactDefinition): void {
    this.definitions.set(definition.id, definition);
  }

  get(id: string): ArtifactDefinition | undefined {
    return this.definitions.get(id);
  }

  all(): readonly ArtifactDefinition[] {
    return [...this.definitions.values()];
  }
}
